import { observable, action } from "mobx";
import Klient from 'src/models/Klient';
import { IApiService } from 'src/services/IApiService';


export default class KlientStore {
    @observable public klients: Klient[] = []

    private api: IApiService;
    constructor(api: IApiService) {
        this.api = api;
    }

    public getClientById(clientId: number): Klient {
        const result = this.klients.filter(a => {
          return a.id === clientId;
        });

        if (result.length > 0) {
            return result[0];
        } else {
            return null;
        }
    }

    @action
    public createNewClientSimple(klientData: Klient): Promise<Klient> {
        const client = klientData.clone();
        client.id = 0;
        client.stridavyRozvoz = 'neresit';

        return new Promise(resolve => {
          this.api.createNewKlient(client)
            .then(klient => {
              this.klients.push(klient);
              resolve(klient);
            });
        });
    }

    @action
    public createNewClient(jmeno: string, prijmeni: string, telefon: string, email: string, ulice: string, mesto: string, poznamka: string, psc: string): Promise<Klient> {
        const client = new Klient();
        client.id = 0;
        client.jmeno = jmeno;
        client.prijmeni = prijmeni;
        client.telefon = telefon;
        client.email = email;
        client.ulice = ulice;
        client.mesto = mesto;
        client.poznamka = poznamka;
        client.PSC = psc;
        client.stridavyRozvoz = 'neresit';

        return new Promise(resolve => {
          this.api.createNewKlient(client)
            .then(klient => {
              this.klients.push(klient);
              resolve(klient);
            });
        });
    }

    @action
    public updateClient(client: Klient): Promise<Klient> {
        return new Promise(resolve => {
          this.api.updateKlient(client)
            .then(klient => {
              resolve(klient);
            });
        });

    }

    @action
    public deleteClient(client: Klient) {
        return new Promise(resolve => {
          this.api.deleteKlient(client)
            .then(klient => {
                const index = this.klients.findIndex(a => a.id === client.id);
                if(index >= 0) {
                    this.klients.splice(index, 1);
                }
                resolve(klient);
            });
        });
    }

    public filterClients(filter: Klient): Klient[] {
      const retVal: Klient[] = [];

      this.klients.forEach((kl: Klient) => {
        let match: boolean = false;

        // telefon
        const klTel = kl.telefon.replace(RegExp("\\s", "g"), "");
        const fTel = filter.telefon.replace(RegExp("\\s", "g"), "");
        if(fTel !== "" && fTel === klTel) {
          match = true;
        }

        // email
        const klEm = kl.email.trim().toUpperCase();
        const fEm = filter.email.trim().toUpperCase();
        if(fEm !== "" && fEm === klEm) {
          match = true;
        }

        if(match) {
          retVal.push(kl);
        }
      });

      return retVal;
    }
}



// WEBPACK FOOTER //
// ./src/stores/KlientStore.tsx